import {
  Box,
  Container,
  containerClasses,
  styled,
  Typography,
  typographyClasses,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { config } from 'public/styles/config';
import { UploadCertificateForm } from 'public/components/certificates/forms/upload-certificate-form/upload-certificate-form';
import { CertificateUploadContentProps } from './types';
import { StyledGreeting } from '../../common';

export const CertificateUploadContent = ({ data }: CertificateUploadContentProps) => {
  const { t } = useTranslation('web-common');
  const { email, firstName, workerId } = data;

  return (
    <StyledContainer>
      <StyledHeader>
        <StyledGreeting>{t('public-pages.greeting.text', { firstName, email })}</StyledGreeting>
        <StyledTitle>{t('upload-certificate-screen.screen-title')}</StyledTitle>
      </StyledHeader>
      <UploadCertificateForm workerId={workerId} />
    </StyledContainer>
  );
};

const StyledTitle = styled(Typography)(({ theme }) => ({
  [`&.${typographyClasses.root}`]: {
    fontSize: theme.typography.pxToRem(36),
    fontWeight: 700,
    color: theme.palette.lwBlack[100],
    fontVariationSettings: '"wght" 700',
    lineHeight: '40px',
  },
}));

const StyledHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  gap: theme.spacing(3),
  marginBottom: theme.spacing(8),
}));

const StyledContainer = styled(Container)({
  [`&.${containerClasses.root}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',

    '& *': {
      fontFamily: config.fontFamily,
    },
  },
});
